module.exports = __webpack_public_path__ + "static/media/edit-gray.f676ad9c.svg";